import { render, staticRenderFns } from "./EmailOrPhoneDiffVt.vue?vue&type=template&id=44bc5b2a&"
import script from "./EmailOrPhoneDiffVt.vue?vue&type=script&lang=js&"
export * from "./EmailOrPhoneDiffVt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
